import { render, staticRenderFns } from "./PalletList.vue?vue&type=template&id=71170a6e&scoped=true"
import script from "./PalletList.vue?vue&type=script&lang=js"
export * from "./PalletList.vue?vue&type=script&lang=js"
import style0 from "./PalletList.vue?vue&type=style&index=0&id=71170a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71170a6e",
  null
  
)

export default component.exports